import { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { ButtonGroup } from "react-bootstrap";
import { Check2Circle, ExclamationCircleFill, FileEarmarkPdf, FiletypeCsv, Justify, Search, SortDown, SortUp } from "react-bootstrap-icons";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import Table from "react-bootstrap/Table";

import { api } from "../../services/Api";
import { AuthContext } from "../../store/AuthContext";
import { dataAtualFormatada, dateTimeStringToISOFormat, montaMenssagemRetornoErroPromiseAllSettled } from './../../util/FuncoesComuns';

import { CSVLink } from "react-csv";
import ToastCustomizado from "../../components/Toast";
import { filtrar } from "../../util/Filtros";
import { IDimensoes } from "../AlertaExpedicao/interfaces/IDimensoes";
import { Mensagem } from "../AlertaExpedicao/utils/mensagem";
import ModalListaLoec from "./Modal/index";
import downloadResumoPdf from "./relatorios/resumoPdf";
import ModalAguarde from "../../components/Modal";


const AlertaLoec = () => {

    const columns = [
        { label: "#", accessor: "#", sortable: false, className: "text-center primeira-coluna", classNameData: "text-center" },
        { label: "Lista", accessor: "numLista", sortable: true, className: "text-center", classNameData: "text-center" },
        { label: "Distrito", accessor: "distrito", sortable: true, className: "text-center", classNameData: "text-center" },
        { label: "Data", accessor: "dataCriacao", sortable: true, className: "", classNameData: "" },
        { label: "Matrícula Entregador", accessor: "matriculaEntregador", sortable: true, className: "text-center", classNameData: "text-center" },
        { label: "Nome Entregador", accessor: "nomeEntregador", sortable: true, className: "text-center", classNameData: "text-center" },
        { label: "Sistema Origem", accessor: "nomeSistemaOrigem", sortable: true, className: "text-center", classNameData: "text-center" },
        { label: "App Operacional", accessor: "isCarregadaSmartphone", sortable: true, className: "text-center", classNameData: "text-center" },
        { label: "Qtd Itens LOEC", accessor: "qtdItensOec", sortable: true, className: "text-center", classNameData: "text-center" },
        { label: "Qtd itens BDE", accessor: "qtdItensBde", sortable: true, className: "text-center", classNameData: "text-center" },
        { label: "Qtd itens BDR", accessor: "qtdItensBdr", sortable: true, className: "text-center", classNameData: "text-center" },
        { label: "Situação", accessor: "acao", sortable: false, className: "text-center", classNameData: "text-center" },
      ];

      const columnsFiltrar = [
        "numLista",
        "distrito",
        "dataCriacao",
        "matriculaEntregador",
        "nomeEntregador",
        "nomeSistemaOrigem",
        "isCarregadaSmartphone",
        "qtdItensOec",
        "qtdItensBde",
        "qtdItensBdr"
      ];

      const ATRIBUTOS_FILTRO_RELATORIO_EXPORT_CSV:any[]=[
      { label: "Lista", key: "numLista"},
      { label: "Distrito", key: "distrito"},
      { label: "Data", key: "dataCriacao"},
      { label: "Matrícula Entregador", key: "matriculaEntregador"},
      { label: "Nome Entregador", key: "nomeEntregador"},
      { label: "Sistema Origem", key: "nomeSistemaOrigem"},
      { label: "App Operacional", key: "isCarregadaSmartphone"},
      { label: "Qtd Itens LOEC", key: "qtdItensOec"},
      { label: "Qtd itens BDE", key: "qtdItensBde"},
      { label: "Qtd itens BDR", key: "qtdItensBdr"}];

      const divTable = useRef<null | HTMLInputElement>(null);
      const [filtro, setFiltro] = useState<string>('');
      const [linhaClicada, setLinhaClicada ] = useState("")
      const [sortField, setSortField] = useState("");
      const [order, setOrder] = useState("asc");

    const { user } = useContext(AuthContext);
    const [, setDimensoes] = useState<IDimensoes>({ width: 0, height: 0});
    const [dataSelecionada, setDataSelecionada] = useState<string>(dataAtualFormatada('ano','-'));
    const [listaLoec, setListaLoec] = useState<any[]>([]);
    const [listaLoecFiltrada, setListaLoecFiltrada] = useState<any[]>([]);
    const [listaLoecSelecionada, setListaLoecSelecionada] = useState<any>(undefined);
    const [listaLoecObjetosSelecionada, setListaLoecObjetosSelecionada] = useState<any>(undefined);
    const [listaLoecObjetosSelecionadaFiltrada, setListaLoecObjetosSelecionadaFiltrada] = useState<any>(listaLoecObjetosSelecionada);
    const [qtdObjetosSemBaixa, setQtdObjetosSemBaixa] = useState<number>(0);
    const [showModalListaLoec, setShowModalListaLoec] = useState<boolean>(false);
    const [showToast, setShowToast] = useState<boolean>(false);
    const [showModalAguarde, setShowModalAguarde] = useState<boolean>(false);
    const [ mensagem, setMensagem ] = useState<Mensagem>({ delay: 5000, tipo: '', texto: '', url: '/alerta-loec' });

    useEffect(() => {
        setShowModalAguarde(()=>false);
        const el = document.getElementById('container-principal');
        const d = {
            width: el ? el.offsetWidth : 0,
            height: el ? el.offsetHeight : 0
        };
        setDimensoes(()=>d)

        consultarListaLoecUnidadeDataSelecionada();

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const handleResize = () => {
        const hm = document.getElementById('header-menu');
        const hmh = hm ? hm.offsetHeight : 0;
        const bp = document.getElementById('breadcrumb-page');
        let bph= bp ? bp.offsetHeight : 0;
        const bpmt = bp ? parseFloat(window.getComputedStyle(bp, null).getPropertyValue('margin-top')) : 0;
        const bpmb = bp ? parseFloat(window.getComputedStyle(bp, null).getPropertyValue('margin-bottom')) : 0;
        const bppt = bp ? parseFloat(window.getComputedStyle(bp, null).getPropertyValue('padding-top')) : 0;
        const bppb = bp ? parseFloat(window.getComputedStyle(bp, null).getPropertyValue('padding-bottom')) : 0;
        bph = bph + bpmt+bpmb+bppt+bppb;

        const fp = document.getElementById('form-page');
        let fph= fp ? fp.offsetHeight : 0;
        const fpmt = fp ? parseFloat(window.getComputedStyle(fp, null).getPropertyValue('margin-top')) : 0;
        const fpmb = fp ? parseFloat(window.getComputedStyle(fp, null).getPropertyValue('margin-bottom')) : 0;
        const fppt = fp ? parseFloat(window.getComputedStyle(fp, null).getPropertyValue('padding-top')) : 0;
        const fppb = fp ? parseFloat(window.getComputedStyle(fp, null).getPropertyValue('padding-bottom')) : 0;
        fph = fph+fpmt+fpmb+fppt+fppb;

        const el = document.getElementById('container-principal');
      const d = {
        width: el ? el.offsetWidth : 0,
        height: el ? el.offsetHeight : 0
      }
        let child = divTable?.current?.children[0] as HTMLDivElement;

        if(d.height > 0 && child) child.style.height=(d.height-(bph+fph+hmh))-30+'px'; 
      };

    const consultarListaLoecUnidadeDataSelecionada = () => {
        setShowToast(()=>false);
        setShowModalAguarde(()=>true);
        (async function () {

          const data = dataSelecionada && dataSelecionada.includes('/') ? dataSelecionada.split('/').reverse().join('-') : dataSelecionada;
          const [resLista] = await Promise.allSettled([api.get(`/v1/resumo-diario-oec?codSroOrigem=${user?.unidadeSro.codigoSro}&dataListasOec=${data}`)]);

          if (resLista.status === 'fulfilled') {
            const res = await resLista.value.data;
            setListaLoec(() => res);
            setListaLoecFiltrada(() => res);

            setMensagem({ delay: 2000, tipo: 'info', texto: `Ok : Consulta realizada com sucesso.`, url: '/alerta-loec' });
            setShowToast(()=>true);
            setShowModalAguarde(()=>false);
          } else if (resLista.status === 'rejected') {
            setListaLoec(()=>[]);
            setListaLoecFiltrada(()=>[]);
            setMensagem({ delay: 5000, tipo: 'danger', texto: montaMenssagemRetornoErroPromiseAllSettled(resLista,'Erro ao chamar /v1/resumo-diario-oec?codSroOrigem={codigoSro}&dataListasOec={data} - Rejeitado.'), url: '/alerta-loec' });
            setShowToast(()=>true);
            setShowModalAguarde(()=>false);
          } else {
            setListaLoec(()=>[]);
            setListaLoecFiltrada(()=>[]);
            setMensagem({ delay: 5000, tipo: 'warning', texto: `Alerta : Erro ao chamar /v1/resumo-diario-oec?codSroOrigem={codigoSro}&dataListasOec={data} - Outros.`, url: '/alerta-loec' });
            setShowModalAguarde(()=>false);
            setShowToast(()=>true);
          }

        })();

    }

    const setFiltroInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        setFiltro(event.target.value)
        if (event.target.value && event.target.value !== '' && event.target.value.length > 0) {

            let res: any = filtrar(listaLoec, columnsFiltrar, event.target.value);

            setListaLoecFiltrada(res)
        } else {
            setListaLoecFiltrada(listaLoec)
        }

    }

    const handleSortingChange = (accessor: string) => {
        const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
        setSortField(accessor);
        setOrder(sortOrder);
        handleSorting(accessor, sortOrder);
    }

    const execute = (e: any, dados: any, i: number, linha: string) => {
        setShowModalAguarde(()=>true);
        setShowToast(()=>false);
        setLinhaClicada(()=>linha);
        setListaLoecSelecionada(()=>dados);


        (async function () {

            const data = dateTimeStringToISOFormat(dados.dataCriacao,'/');

            const [resLista] = await Promise.allSettled([api.get(`/v1/resumo-diario-oec/itens?codSroOrigem=${user?.unidadeSro.codigoSro}&dataListaOec=${data}&matricula=${dados.matriculaEntregador}&numListaOec=${dados.numLista}`)]);

            if (resLista.status === 'fulfilled') {
              const res = await resLista.value.data;
              setListaLoecObjetosSelecionada(() => res);
              setListaLoecObjetosSelecionadaFiltrada(() => res);

                let qtd=0;

                if(res && res.length > 0){
                    res.forEach((e: { eventoBaixa: string; }) => {
                    qtd = e.eventoBaixa ? qtd : qtd+1;

                  });
                }
                setQtdObjetosSemBaixa(()=>qtd)

                setMensagem({ delay: 2000, tipo: 'info', texto: `Ok : Consulta realizada com sucesso.`, url: '/alerta-loec' });
                setShowModalAguarde(()=>false);
                setShowToast(()=>true);
              } else if (resLista.status === 'rejected') {
                setListaLoec(()=>[]);
                setListaLoecFiltrada(()=>[]);
                setMensagem({ delay: 5000, tipo: 'danger', texto: montaMenssagemRetornoErroPromiseAllSettled(resLista,'Erro ao chamar /v1/resumo-diario-oec?codSroOrigem={codigoSro}&dataListasOec={data}&matricula={matricula} - Rejeitado.'), url: '/alerta-loec' });
                setShowModalAguarde(()=>false);
                setShowToast(()=>true);
              } else {
                setListaLoec(()=>[]);
                setListaLoecFiltrada(()=>[]);
                setMensagem({ delay: 5000, tipo: 'warning', texto: `Alerta : /v1/resumo-diario-oec?codSroOrigem={codigoSro}&dataListasOec={data}&matricula={matricula} - Outros.`, url: '/alerta-loec' });
                setShowModalAguarde(()=>false);
                setShowToast(()=>true);
              }
              setShowModalListaLoec(()=>true);
          })();
    }

      const handleSorting = (sortField: string | number, sortOrder: string) => {

        if (sortField) {
            const sorted = [...listaLoecFiltrada].sort((a, b) => {
                if ((a as Record<string, any>)[sortField] === null) return 1;
                if ((b as Record<string, any>)[sortField] === null) return -1;
                if ((a as Record<string, any>)[sortField] === null && (b as Record<string, any>)[sortField] === null) return 0;
                return (
                    (a as Record<string, any>)[sortField].toString().localeCompare((b as Record<string, any>)[sortField].toString(), "pt-BR", {
                        numeric: true,
                    }) * (sortOrder === "asc" ? 1 : -1)
                );
            });

            setListaLoecFiltrada(sorted);
        }
      };

    const inserirIcon = (dadosLinha: any) => {
      return dadosLinha && dadosLinha.qtdItensOec && dadosLinha.qtdItensOec <= (dadosLinha.qtdItensBde+dadosLinha.qtdItensBdr) ? true : false;
    }

    return (

        <>
        <Breadcrumb id="breadcrumb-page">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>{'Alerta LOEC'}</Breadcrumb.Item>
            </Breadcrumb>
        <Form id="form-page" className="border rounded p-2 mb-3">

        <Form.Group as={Row} controlId="formListaLoec">
          <Col sm={12} lg={6} xl={3}>
            <Form.Control
              type="search"
              placeholder="Filtrar"
              title="Digite algo para filtrar."
              disabled={!filtro && (!listaLoecFiltrada || listaLoecFiltrada.length === 0)}
              value={filtro}
              onChange={setFiltroInput}
            />
          </Col>
          <Col sm={12} lg={6} xl={3}>
            <InputGroup>
              <Form.Control
                type="date"
                placeholder="Selecione data"
                title="Selecione uma data para consultar."
                aria-describedby="basic-addon2"
                value={dataSelecionada && dataSelecionada !== '1900-01-01' ? dataSelecionada : ''} onChange={(e) => setDataSelecionada(e.target.value)}
              />
              <Button variant="primary" className="ps-1 py-0" id="button-addon2"
                title="Ao ser clicado consulta os unitizadores da data selecionada."
                disabled={!dataSelecionada}
                onClick={consultarListaLoecUnidadeDataSelecionada}>
                <Search className="icon-search" />
                Consultar
              </Button>
            </InputGroup>
          </Col>
          <Col sm={12} lg={12} xl={{ span: 3, offset: 3 }}>
          <ButtonGroup className='mb-2 w-100 h-100'>
                {listaLoecFiltrada.length > 0 ?
                  <CSVLink headers={ATRIBUTOS_FILTRO_RELATORIO_EXPORT_CSV} data={listaLoecFiltrada} separator={';'} filename={"resumoLoec.csv"} className="btn btn-primary" type="button"><FiletypeCsv color='white' size={24}/> CSV</CSVLink>
                  :
                  <Button variant="primary" disabled={listaLoecFiltrada.length === 0}><FiletypeCsv color='white' size={24}/> CSV</Button>
                }
                  <Button variant="primary" disabled={listaLoecFiltrada.length === 0} onClick={() => downloadResumoPdf(listaLoecFiltrada,dataSelecionada.split('-').reverse().join('/'),user,filtro)}><FileEarmarkPdf color='red' size={24}/> PDF</Button>
              </ButtonGroup>
          </Col>
        </Form.Group>

      </Form>

        <div ref={divTable} className="mb-5">
        <Table id="tabela-lista-loec" responsive striped className="scroll mb-0">
          <thead>
            <tr>
              {columns.map(({ label, accessor, sortable, className }) => {

                const cl = sortable ? sortField === accessor && order === "asc"
                  ? <SortUp className="icon-table-sortable" />
                  : sortField === accessor && order === "desc"
                    ? <SortDown className="icon-table-sortable" />
                    : <Justify className="icon-table-sortable" />
                  : "";

                return (
                  <th
                    key={accessor}
                    className={`${sortable ? `${className} cursor-pointer` : `${className}`}`}
                    onClick={sortable ? () => handleSortingChange(accessor) : undefined}
                  >
                    {cl}
                    {label}
                  </th>
                );
              })}
            </tr>
          </thead>
          { listaLoecFiltrada && listaLoecFiltrada.length > 0 ?

            (<tbody>
              {listaLoecFiltrada.map((data: any, index: number) => {

                let i = ++index;
                let naoPendencia = inserirIcon(data);
                return (

                  <tr id={String(index)} key={index ? index : 0} className={data.dataCriacao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', '') !== linhaClicada ? 'cursor-pointer' : 'cursor-pointer row-selecionada'} onClick={(e) => execute(e, data, i, data.dataCriacao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', ''))}>
                    {columns.map(({ accessor, classNameData }) => {

                      const tData = (data as Record<string, any>)[accessor] || (data as Record<string, any>)[accessor] >= 0 ? (data as Record<string, any>)[accessor] : accessor === "#" ? index : "link";

                      return tData !== "link" ? <td id={accessor} key={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>{tData}</td>
                        :
                        <td id={accessor} key={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>
                          <Link to="#" id="btn-bottom-voltar"
                            className={data.dataCriacao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', '') !== linhaClicada ? 'me-2 text-secondary' : 'me-2 text-success'}
                            title={naoPendencia ? 'Lista baixada.' : 'Lista com pendência de baixa ou com item estornado.'}
                            role="button" onClick={(e) => execute(e, data, i, data.dataCriacao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', ''))}>
                            {naoPendencia ? <Check2Circle className="icon-pre-alerta text-success" /> : <ExclamationCircleFill className="icon-pre-alerta text-warning" size={2} />}
                          </Link>
                        </td>
                    })}
                  </tr>
                );
              })}
            </tbody>)

          :

            (<tbody><tr><td colSpan={columns.length} className="text-center"><strong className="text-center">Não encontrou dados.</strong></td></tr></tbody>)
          }

        </Table>
      </div>

      <ModalListaLoec
        listaLoecSelecionada={listaLoecSelecionada}
        listaLoecObjetosSelecionada={listaLoecObjetosSelecionada}
        listaLoecObjetosSelecionadaFiltrada={listaLoecObjetosSelecionadaFiltrada}
        setListaLoecObjetosSelecionadaFiltrada={setListaLoecObjetosSelecionadaFiltrada}
        qtdObjetosSemBaixa={qtdObjetosSemBaixa}
        show={showModalListaLoec}
        setShow={setShowModalListaLoec}
      />

      { showToast ?
            <ToastCustomizado
              show={showToast}
              setShow={setShowToast}
              mensagem={mensagem && mensagem.texto ? mensagem.texto : undefined}
              tipo={mensagem && mensagem.tipo ? mensagem.tipo : ''}
              delay={mensagem?.delay}
            />
            : null }

        <ModalAguarde show={showModalAguarde} setShow={setShowModalAguarde}/>
      </>
    )

}

export default AlertaLoec
